import React from 'react';
import { Grid, Modal } from '@mui/material';
import { BackupCodesContainerProps } from './types';

const BackupCodesContainer = ({ children, handleClose, isModal = false, openModal }: BackupCodesContainerProps) => {
  if (isModal) {
    return (
      <Modal
        open={!!openModal}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description">
        {children}
      </Modal>
    );
  }

  return <Grid container>{children}</Grid>;
};

export default BackupCodesContainer;
